var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226.77,
    height: 302.83,
    viewBox: "0 0 226.77 302.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 0 302.83)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m81.103 175.53c-27.944-25.068-15.31-49.331-15.31-49.331-1.382 20.483 6.481 28.471 27.1 49.138 22.705 22.747 7.998 47.872 7.998 47.872s7.887-22.858-19.788-47.679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.731 155.9c-18.915-14.025-16.793-29.229-16.793-29.229 0.897 3.745 1.665 9.503 23.09 25.462 27.348 20.372 19.766 39.63 19.766 39.63-1.547-12.722-7.152-21.841-26.063-35.863"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.572 142.95c-15.844-6.245-17.215-17.264-17.215-17.264 1.327 2.449 2.944 6.328 20.911 13.45 22.926 9.096 21.245 23.972 21.245 23.972-3.47-8.596-9.095-13.913-24.941-20.158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.951 83.755c-22.706-22.755-7.999-47.877-7.999-47.877s-7.886 22.859 19.789 47.68c27.944 25.065 15.311 49.33 15.311 49.33 1.379-20.482-6.483-28.472-27.101-49.133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.817 106.95c-27.351-20.367-19.77-39.626-19.77-39.626 1.55 12.722 7.153 21.84 26.067 35.863 18.91 14.023 16.789 29.232 16.789 29.232-0.893-3.749-1.663-9.505-23.086-25.469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.578 119.95c-22.93-9.096-21.249-23.974-21.249-23.974 3.47 8.598 9.099 13.916 24.944 20.161 15.842 6.245 17.215 17.263 17.215 17.263-1.331-2.45-2.948-6.326-20.91-13.45"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeLogo);
export default __webpack_public_path__ + "static/media/ke_logo.049fd33349ce35b2be2995a3889e1bc4.svg";
export { ForwardRef as ReactComponent };